const contactSchema = {
  description: '',
  contacts: [],
};

export default contactSchema;
